import React, { useState } from "react";
import "../../Styles/LocalLeadersTable.css";
import { useNavigate } from "react-router-dom";

const AdminLocalLeadersTable = () => {
  const navigate = useNavigate();

  /* ===================== MANDAL → VILLAGE MAPPING ===================== */
  const mandalVillages = {
    Kandukur: [
      "Anandapuram", "Anantha Sagaram", "Donda Padu", "G.Meka Padu",
      "Jillelamudi", "Kancharagunta", "Kondamudusu Palem", "Kandukur",
      "Kovur", "Machavaram", "Madanagopalapuram", "Mahadevapuram",
      "Mopadu", "Muppalakesaram", "Ogur", "Palukur", "Palur",
      "Pandalapadu", "Vikkiralapeta",
    ],
    Lingasamudram: [
      "Anneboinapalle", "Cheemalapenta", "Chinapavani", "Gangapalem",
      "Jagamreddi Khandrika", "Lingasamudram", "Malakondarayunipalem",
      "Mogilicherla", "Mukteswaram", "Mutyalapadu", "Narasimhapuram",
      "Pentrala", "Racheruvurajupalem", "Rallapadu", "Thimmareddypalem",
      "Thunugunta", "Thurpu Rajupalem", "Veeraraghavunikota",
      "Vengalapuram", "Viswanadhapuram",
    ],
    Gudluru: [
      "Ammavaripalem", "Basireddypalem", "Chevuru", "Chinalatrapi",
      "Dappalampadu", "Darakanipadu", "Gudluru", "Gundlapalem",
      "Kothapeta", "Mocherla", "Nayudupalem", "Parakondapadu Agraharam",
      "Parakondapadu", "Potluru", "Puretipalle", "Ravur",
      "Swarnajipuram", "Venkampeta",
    ],
    Ulavapadu: [
      "Atmakur", "Baddepudi", "Bheemavaram", "Chagallu", "Chaki Cherla",
      "K. Rajupalem", "Karedu", "Kollurupadu", "Krishnapuram",
      "Manneti Kota", "Ramayapatnam", "Veerepalle",
    ],
    "Valletivari Palem": [
      "Ayyavaripalle", "Chundi", "East Polineni Palem", "Kakutur",
      "Kalavalla", "Kondareddipalem", "Kondasamudram", "Naladalapur",
      "Nawabpalem", "Nekunam Puram K.Kandrika", "Nekunampuram @ Pokur",
      "Nukavaram", "Polineni Cheruvu", "Ramachandrapuram",
      "Ramalingapuram", "Sakhavaram", "Sameerapalem", "Singamnenipalle",
      "Veeranna Palem", "Voletivaripalem", "Z. Uppalapadu",
    ],
  };

  const initialData = [
    {
      id: 1,
      name: "Sri P. Rajasekhar Reddy",
      alias: "Rajasekhar Garu",
      position: "Mandal President",
      mandal: "Kandukur",
      village: "Kandukur",
      contact: "+91 9876543210",
      status: "Active",
      //   photo: "https://randomuser.me/api/portraits/men/32.jpg",
    },
    {
      id: 2,
      name: "Sri B. Venkat Rao",
      alias: "Venkat Rao Garu",
      position: "Mandal Vice President",
      mandal: "Gudluru",
      village: "Gudluru",
      contact: "+91 9123456780",
      status: "Active",
      //   photo: "https://randomuser.me/api/portraits/men/54.jpg",
    },
    {
      id: 3,
      name: "Smt. Ch. Padmavathi",
      alias: "Padma Garu",
      position: "Mandal Mahila President",
      mandal: "Ulavapadu",
      village: "Atmakur",
      contact: "+91 9988776655",
      status: "Active",
      //   photo: "https://randomuser.me/api/portraits/women/68.jpg",
    },
    {
      id: 4,
      name: "Sri K. Suresh Babu",
      alias: "Suresh Babu Garu",
      position: "Mandal General Secretary",
      mandal: "Kandukur",
      village: "Kovur",
      contact: "+91 9345678901",
      status: "Inactive",
      //   photo: "https://randomuser.me/api/portraits/men/76.jpg",
    },
    {
      id: 5,
      name: "Sri M. Ramesh",
      alias: "Ramesh Garu",
      position: "Mandal Treasurer",
      mandal: "Gudluru",
      village: "Mocherla",
      contact: "+91 9012345678",
      status: "Active",
      //   photo: "https://randomuser.me/api/portraits/men/41.jpg",
    },
  ];

  const [leaders, setLeaders] = useState(initialData);

  const [search, setSearch] = useState("");
  const [mandalFilter, setMandalFilter] = useState("All Mandals");
  const [villageFilter, setVillageFilter] = useState("All Villages");
  const [statusFilter, setStatusFilter] = useState("All Status");
  const [currentPage, setCurrentPage] = useState(1);

  const [showEditModal, setShowEditModal] = useState(false);
  const [editItem, setEditItem] = useState(null);

  const totalPages = 5;

  const resetFilters = () => {
    setSearch("");
    setMandalFilter("All Mandals");
    setVillageFilter("All Villages");
    setStatusFilter("All Status");
  };

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) setCurrentPage(page);
  };

  // ---------- SEARCH + FILTER LOGIC ----------
  const filteredLeaders = leaders.filter((item) => {
    const searchLower = search.trim().toLowerCase();

    const matchesSearch =
      searchLower === "" ||
      item.name.toLowerCase().includes(searchLower) ||
      item.position.toLowerCase().includes(searchLower);

    const matchesMandal =
      mandalFilter === "All Mandals" || item.mandal === mandalFilter;

    const matchesVillage =
      villageFilter === "All Villages" || item.village === villageFilter;

    const matchesStatus =
      statusFilter === "All Status" || item.status === statusFilter;

    return matchesSearch && matchesMandal && matchesVillage && matchesStatus;
  });

  // ---------- EDIT LOGIC ----------
  const openEditModal = (item) => {
    setEditItem({ ...item });
    setShowEditModal(true);
  };

  const closeEditModal = () => {
    setShowEditModal(false);
    setEditItem(null);
  };

  const handleEditChange = (e) => {
    const { name, value } = e.target;

    if (name === "mandal") {
      // when mandal changes in the edit modal, reset village
      // to the first village of the newly selected mandal
      const firstVillage = mandalVillages[value]?.[0] || "";
      setEditItem((prev) => ({
        ...prev,
        mandal: value,
        village: firstVillage,
      }));
      return;
    }

    setEditItem((prev) => ({ ...prev, [name]: value }));
  };

  const handleEditSave = (e) => {
    e.preventDefault();
    setLeaders((prev) =>
      prev.map((item) => (item.id === editItem.id ? editItem : item))
    );
    closeEditModal();
  };

  // ---------- STATS ----------
  const totalLeaders = leaders.length;
  const activeLeaders = leaders.filter((l) => l.status === "Active").length;
  const inactiveLeaders = leaders.filter((l) => l.status === "Inactive").length;
  const totalMandals = new Set(leaders.map((l) => l.mandal)).size;

  const activePct = totalLeaders
    ? ((activeLeaders / totalLeaders) * 100).toFixed(2)
    : 0;
  const inactivePct = totalLeaders
    ? ((inactiveLeaders / totalLeaders) * 100).toFixed(2)
    : 0;

  // ---------- FILTER: village dropdown options depend on selected mandal filter ----------
  const villageFilterOptions =
    mandalFilter === "All Mandals" ? [] : mandalVillages[mandalFilter] || [];

  return (
    <div className="ldr123-page">
      {/* Header */}
      <div className="ldr123-header">
        <div>
          <h2 className="ldr123-title">Local Political Leaders</h2>
          <p className="ldr123-subtitle">
            Manage and view local political leaders in your constituency
          </p>
        </div>

        <button
          className="ldr123-add-btn"
          onClick={() => navigate("/AdminDashboard/AdminLocalLeadersForm")}
        >
          <span className="ldr123-add-icon">+</span> Add New Leader
        </button>
      </div>

      {/* Stat Cards */}
      <div className="ldr123-stats-grid">
        <div className="ldr123-stat-card">
          <div className="ldr123-stat-icon ldr123-icon-blue">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
              <circle cx="9" cy="8" r="3.2" stroke="currentColor" strokeWidth="1.7" />
              <path d="M3 20c0-3.3 2.7-5.5 6-5.5s6 2.2 6 5.5" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
              <circle cx="17" cy="8" r="2.6" stroke="currentColor" strokeWidth="1.7" />
              <path d="M15.5 14.7c2.6.4 4.5 2.3 4.5 5.3" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
            </svg>
          </div>
          <div className="ldr123-stat-info">
            <span className="ldr123-stat-label">Total Leaders</span>
            <span className="ldr123-stat-value">{totalLeaders}</span>
            <span className="ldr123-stat-sub">All Leaders</span>
          </div>
        </div>

        <div className="ldr123-stat-card">
          <div className="ldr123-stat-icon ldr123-icon-green">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
              <circle cx="12" cy="9" r="3.5" stroke="currentColor" strokeWidth="1.7" />
              <path d="M4 20c0-3.6 3.6-6 8-6s8 2.4 8 6" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
              <path d="M9.5 9l1.8 1.8L15 7" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </div>
          <div className="ldr123-stat-info">
            <span className="ldr123-stat-label">Active Leaders</span>
            <span className="ldr123-stat-value">{activeLeaders}</span>
            <span className="ldr123-stat-sub ldr123-sub-green">{activePct}% of total</span>
          </div>
        </div>

        <div className="ldr123-stat-card">
          <div className="ldr123-stat-icon ldr123-icon-orange">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
              <circle cx="12" cy="9" r="3.5" stroke="currentColor" strokeWidth="1.7" />
              <path d="M4 20c0-3.6 3.6-6 8-6s8 2.4 8 6" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
              <path d="M9.5 7l4 4M13.5 7l-4 4" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
            </svg>
          </div>
          <div className="ldr123-stat-info">
            <span className="ldr123-stat-label">Inactive Leaders</span>
            <span className="ldr123-stat-value">{inactiveLeaders}</span>
            <span className="ldr123-stat-sub ldr123-sub-orange">{inactivePct}% of total</span>
          </div>
        </div>

        <div className="ldr123-stat-card">
          <div className="ldr123-stat-icon ldr123-icon-purple">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
              <path
                d="M12 22s7-6.5 7-12a7 7 0 10-14 0c0 5.5 7 12 7 12z"
                stroke="currentColor"
                strokeWidth="1.8"
                strokeLinejoin="round"
              />
              <circle cx="12" cy="10" r="2.5" stroke="currentColor" strokeWidth="1.8" />
            </svg>
          </div>
          <div className="ldr123-stat-info">
            <span className="ldr123-stat-label">Total Mandals</span>
            <span className="ldr123-stat-value">{totalMandals}</span>
            <span className="ldr123-stat-sub">Kandukur Constituency</span>
          </div>
        </div>
      </div>

      {/* Filters */}
      <div className="ldr123-filters">
        <div className="ldr123-search-box">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
            <circle cx="11" cy="11" r="7" stroke="currentColor" strokeWidth="2" />
            <path d="M21 21l-4-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
          </svg>
          <input
            type="text"
            placeholder="Search leader by name, position..."
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
              setCurrentPage(1);
            }}
          />
        </div>

        <select
          className="ldr123-select"
          value={mandalFilter}
          onChange={(e) => {
            setMandalFilter(e.target.value);
            setVillageFilter("All Villages");
            setCurrentPage(1);
          }}
        >
          <option>All Mandals</option>
          <option>Kandukur</option>
          <option>Gudluru</option>
          <option>Ulavapadu</option>
          <option>Lingasamudram</option>
          <option>Valletivari Palem</option>
        </select>

        <select
          className="ldr123-select"
          value={villageFilter}
          onChange={(e) => {
            setVillageFilter(e.target.value);
            setCurrentPage(1);
          }}
          disabled={mandalFilter === "All Mandals"}
        >
          <option>All Villages</option>
          {villageFilterOptions.map((village) => (
            <option key={village} value={village}>
              {village}
            </option>
          ))}
        </select>

        <select
          className="ldr123-select"
          value={statusFilter}
          onChange={(e) => {
            setStatusFilter(e.target.value);
            setCurrentPage(1);
          }}
        >
          <option>All Status</option>
          <option>Active</option>
          <option>Inactive</option>
        </select>

        <button className="ldr123-reset-btn" onClick={resetFilters}>
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
            <path
              d="M4 4v6h6M20 20v-6h-6M4.5 15a8 8 0 0014.5 3.5M19.5 9A8 8 0 005 5.5"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          Reset Filters
        </button>
      </div>

      {/* Table */}
      <div className="ldr123-table-wrapper">
        <table className="ldr123-table">
          <thead>
            <tr>
              <th>S.No</th>
              <th>Photo</th>
              <th>Name</th>
              <th>Position</th>
              <th>Village</th>
              <th>Mandal</th>
              <th>Contact</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {filteredLeaders.length === 0 ? (
              <tr>
                <td colSpan="9" className="ldr123-no-data">
                  No leaders found.
                </td>
              </tr>
            ) : (
              filteredLeaders.map((item, index) => (
                <tr key={item.id}>
                  <td>{index + 1}</td>

                  <td>
                    <img
                      src={item.photo}
                      alt={item.name}
                      className="ldr123-photo"
                    />
                  </td>

                  <td>
                    <div className="ldr123-name-cell">
                      <span className="ldr123-name-text">{item.name}</span>
                      <span className="ldr123-alias-text">{item.alias}</span>
                    </div>
                  </td>

                  <td>{item.position}</td>

                  <td>
                    <div className="ldr123-place-cell">
                      <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
                        <path
                          d="M12 22s7-6.5 7-12a7 7 0 10-14 0c0 5.5 7 12 7 12z"
                          stroke="currentColor"
                          strokeWidth="1.7"
                          strokeLinejoin="round"
                        />
                        <circle cx="12" cy="10" r="2.5" stroke="currentColor" strokeWidth="1.7" />
                      </svg>
                      {item.village}
                    </div>
                  </td>

                  <td>{item.mandal}</td>

                  <td>
                    <div className="ldr123-contact-cell">
                      <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
                        <path d="M22 16.9v3a2 2 0 01-2.2 2 19.8 19.8 0 01-8.6-3.1 19.5 19.5 0 01-6-6A19.8 19.8 0 012.1 4.2 2 2 0 014.1 2h3a2 2 0 012 1.7c.1.9.3 1.8.6 2.7a2 2 0 01-.5 2.1L8 9.7a16 16 0 006 6l1.2-1.2a2 2 0 012.1-.5c.9.3 1.8.5 2.7.6a2 2 0 011.7 2z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
                      </svg>
                      {item.contact}
                    </div>
                  </td>

                  <td>
                    <span
                      className={`ldr123-status-badge ${
                        item.status === "Active"
                          ? "ldr123-status-active"
                          : "ldr123-status-inactive"
                      }`}
                    >
                      {item.status === "Active" ? (
                        <svg width="10" height="10" viewBox="0 0 24 24" fill="none">
                          <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2.2" />
                          <path d="M8.5 12.5l2.5 2.5 4.5-5" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                      ) : (
                        <svg width="10" height="10" viewBox="0 0 24 24" fill="none">
                          <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2.2" />
                          <path d="M15 9l-6 6M9 9l6 6" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />
                        </svg>
                      )}
                      {item.status}
                    </span>
                  </td>

                  <td>
                    <div className="ldr123-action-cell">
                      <button
                        className="ldr123-edit-btn"
                        onClick={() => openEditModal(item)}
                        title="Edit"
                      >
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                          <path
                            d="M12 20h9M16.5 3.5a2.1 2.1 0 013 3L7 19l-4 1 1-4 12.5-12.5z"
                            stroke="currentColor"
                            strokeWidth="1.9"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      <div className="ldr123-pagination-bar">
        <span className="ldr123-pagination-info">
          Showing 1 to {filteredLeaders.length} of {totalLeaders} leaders
        </span>

        <div className="ldr123-pagination-controls">
          <button
            className="ldr123-page-arrow"
            onClick={() => handlePageChange(currentPage - 1)}
          >
            &lt;
          </button>

          {[1, 2, 3].map((p) => (
            <button
              key={p}
              className={`ldr123-page-num ${currentPage === p ? "ldr123-active" : ""}`}
              onClick={() => handlePageChange(p)}
            >
              {p}
            </button>
          ))}

          <span className="ldr123-page-dots">...</span>

          <button
            className={`ldr123-page-num ${currentPage === totalPages ? "ldr123-active" : ""}`}
            onClick={() => handlePageChange(totalPages)}
          >
            {totalPages}
          </button>

          <button
            className="ldr123-page-arrow"
            onClick={() => handlePageChange(currentPage + 1)}
          >
            &gt;
          </button>
        </div>
      </div>

      {/* ---------------- EDIT MODAL ---------------- */}
      {showEditModal && editItem && (
        <div className="ldr123-modal-overlay" onClick={closeEditModal}>
          <div className="ldr123-modal" onClick={(e) => e.stopPropagation()}>
            <div className="ldr123-modal-header">
              <h3>Edit Leader</h3>
              <button className="ldr123-modal-close" onClick={closeEditModal}>
                &times;
              </button>
            </div>

            <form className="ldr123-modal-body" onSubmit={handleEditSave}>
              <div className="ldr123-form-row">
                <div className="ldr123-form-group">
                  <label>Name</label>
                  <input
                    type="text"
                    name="name"
                    value={editItem.name}
                    onChange={handleEditChange}
                    required
                  />
                </div>

                <div className="ldr123-form-group">
                  <label>Alias</label>
                  <input
                    type="text"
                    name="alias"
                    value={editItem.alias}
                    onChange={handleEditChange}
                  />
                </div>
              </div>

              <div className="ldr123-form-group">
                <label>Position</label>
                <input
                  type="text"
                  name="position"
                  value={editItem.position}
                  onChange={handleEditChange}
                  required
                />
              </div>

              <div className="ldr123-form-row">
                <div className="ldr123-form-group">
                  <label>Mandal</label>
                  <select
                    name="mandal"
                    value={editItem.mandal}
                    onChange={handleEditChange}
                  >
                    {Object.keys(mandalVillages).map((mandal) => (
                      <option key={mandal} value={mandal}>
                        {mandal}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="ldr123-form-group">
                  <label>Village</label>
                  <select
                    name="village"
                    value={editItem.village}
                    onChange={handleEditChange}
                  >
                    {(mandalVillages[editItem.mandal] || []).map((village) => (
                      <option key={village} value={village}>
                        {village}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="ldr123-form-row">
                <div className="ldr123-form-group">
                  <label>Contact</label>
                  <input
                    type="text"
                    name="contact"
                    value={editItem.contact}
                    onChange={handleEditChange}
                    required
                  />
                </div>

                <div className="ldr123-form-group">
                  <label>Status</label>
                  <select
                    name="status"
                    value={editItem.status}
                    onChange={handleEditChange}
                  >
                    <option>Active</option>
                    <option>Inactive</option>
                  </select>
                </div>
              </div>

              <div className="ldr123-modal-footer">
                <button
                  type="button"
                  className="ldr123-btn-cancel"
                  onClick={closeEditModal}
                >
                  Cancel
                </button>
                <button type="submit" className="ldr123-btn-save">
                  Save Changes
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminLocalLeadersTable;